import { render, staticRenderFns } from "./UserTableItemInfos.vue?vue&type=template&id=a9939194&scoped=true"
import script from "./UserTableItemInfos.vue?vue&type=script&lang=js"
export * from "./UserTableItemInfos.vue?vue&type=script&lang=js"
import style0 from "./UserTableItemInfos.vue?vue&type=style&index=0&id=a9939194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9939194",
  null
  
)

export default component.exports